import { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FormStepIndicator } from '@/components/ui/form-step-indicator';
import { Building, FastForward } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface OnboardingLayoutProps {
  children: ReactNode;
  currentStep: number;
  totalSteps: number;
  stepTitles: string[];
  establishmentName: string;
  onSkipAll?: () => void;
  showSkipAll?: boolean;
}

export function OnboardingLayout({
  children,
  currentStep,
  totalSteps,
  stepTitles,
  establishmentName,
  onSkipAll,
  showSkipAll = true,
}: OnboardingLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-muted/30 to-background py-8 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Building className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-2xl font-serif font-bold text-foreground">
            Bienvenue chez {establishmentName} !
          </h1>
          <p className="text-muted-foreground mt-2">
            Configurons votre établissement en quelques étapes
          </p>
          
          {/* Skip All Button - only visible before final step */}
          {showSkipAll && currentStep < totalSteps && onSkipAll && (
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={onSkipAll}
              className="mt-3 text-muted-foreground hover:text-foreground"
            >
              <FastForward className="w-4 h-4 mr-2" />
              Passer tout
            </Button>
          )}
        </div>

        {/* Step Indicator */}
        <div className="mb-8">
          <FormStepIndicator
            currentStep={currentStep}
            totalSteps={totalSteps}
            stepTitles={stepTitles}
          />
        </div>

        {/* Content */}
        <Card className="shadow-lg">
          <CardContent className="pt-6">
            {children}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
